import React from "react";
import Lottie from "react-lottie";
import * as LoadingAnim from "./load.json";
import * as DoneAnim from "./done.json";

const loadingOptions = {
  loop: true,
  autoplay: true,
  animationData: LoadingAnim.default,
  rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
};

const doneOptions = {
  loop: false,
  autoplay: true,
  animationData: DoneAnim.default,
  rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
};

const Animation = ({ isLoading }) => (
  <div style={{ marginTop: "10rem", textAlign:"center" }}>
    {isLoading ? (
      <Lottie options={loadingOptions} height={300} width={300} />
    ) : (
      <Lottie options={doneOptions} height={300} width={300} />
    )}
  </div>
);

export default Animation;
